<template>
  <v-card class="rounded-lg white">
    <v-card-title>تسویه حساب شریک</v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5" lg="4">
          <PartnerSelect v-model="partnerId" label="انتخاب شریک" placeholder="یک شریک را انتخاب کنید" clearable />
        </v-col>
      </v-row>

      <div v-if="!partnerId" class="text-center py-12 grey--text">
        برای دیدن تسویه حساب، یک شریک را انتخاب کنید.
      </div>

      <div v-else class="admin-dark-panel rounded-lg pa-3 mt-2">
        <PartnerCalculationsSettlement :key="partnerId" :partner-id="partnerId" @go-to-returns="goToReturns" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartnerSelect from "@/components/selects/PartnerSelect"
import PartnerCalculationsSettlement from "./PartnerCalculationsSettlement"
import adminPartnerSelection from "./adminPartnerSelectionMixin"

export default {
  name: 'AdminPartnerCalculationsSettlementPage',

  mixins: [adminPartnerSelection],

  components: { PartnerSelect, PartnerCalculationsSettlement },

  methods: {
    goToReturns() {
      this.$router.push({ name: 'AdminPartnerCalculationsReturnsPage' })
    },
  },
}
</script>

<style scoped>
.admin-dark-panel {
  background-color: #111827;
}
</style>
